import { type ComponentProps } from "solid-js"
import icon from "../assets/branding/openanalyst-project-icon.png"

export const Mark = (props: { class?: string }) => {
  return (
    <img
      data-component="logo-mark"
      src={icon}
      alt="OpenAnalyst"
      classList={{ [props.class ?? ""]: !!props.class }}
    />
  )
}

type AnimatedMarkProps = {
  class?: string
  autoplay?: boolean
  respectReducedMotion?: boolean
  minOpacity?: number
  durationMs?: number
}

export const AnimatedMark = (props: AnimatedMarkProps) => {
  const respect = props.respectReducedMotion ?? true
  const minOpacity = props.minOpacity ?? 0.35
  const duration = props.durationMs ?? 2000

  return (
    <img
      data-component="animated-mark"
      data-autoplay={props.autoplay ? "true" : undefined}
      data-respect-reduced-motion={respect ? "true" : undefined}
      classList={{ "animated-mark": true, [props.class ?? ""]: !!props.class }}
      src={icon}
      alt="OpenAnalyst"
      style={`--animated-mark-min: ${minOpacity}; --animated-mark-duration: ${duration}ms;`}
    />
  )
}

export const Splash = (props: Pick<ComponentProps<"img">, "ref" | "class">) => {
  return (
    <img
      ref={props.ref}
      data-component="logo-splash"
      classList={{ [props.class ?? ""]: !!props.class }}
      src={icon}
      alt=""
      aria-hidden="true"
    />
  )
}

export const Logo = (props: { class?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 234 42"
      role="img"
      aria-label="OpenAnalyst"
      data-component="logo"
      classList={{ [props.class ?? ""]: !!props.class }}
    >
      <image
        href={icon}
        x="0"
        y="0"
        width="42"
        height="42"
        preserveAspectRatio="xMidYMid meet"
      />
      <text
        data-component="logo-wordmark"
        x="54"
        y="31"
        fill="var(--text-strong-base, currentColor)"
        font-family="ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        font-size="28"
        font-weight="600"
        letter-spacing="0"
        textLength="176"
        lengthAdjust="spacingAndGlyphs"
      >
        OpenAnalyst
      </text>
    </svg>
  )
}
